export default [
    require('./user').default, 
    require('./app').default, 
    require('./ad').default, 
    require('./search').default, 
]



// WEBPACK FOOTER //
// ./src/model/index.js